import React, { useState } from 'react'
import { Wrapper } from './style'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'
import { PlanTypes } from 'src/redux/types/planTypes'
import { ModalButton } from 'src/components/Global/Button/Button'
import { PlanAmountModal } from './plans-redux-modal/PlanAmount'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { ModalTitleText } from 'src/components/Global/Text/TitleText'
const PlanTimeLine = () => {
  let today = new Date()

  let date =
    today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
  const [planData, setPlanData] = useState({
    start_date: date,
    maturity_date: '',
    timeline: '',
  })

  const TIMELINE = [
    {
      code: '1',
      name: '1 Month',
    },
    {
      code: '2',
      name: '2 Months',
    },
    {
      code: '3',
      name: '3 Months',
    },
    {
      code: '4',
      name: '4 Months',
    },
    {
      code: '6',
      name: '6 Months',
    },
    {
      code: '12',
      name: '1 Year',
    },
    {
      code: '24',
      name: '2 Year',
    },
  ]
  const dispatch = useDispatch()

  const [showModal, setShowModal] = useState(false)
  const createPlan = (e: any) => {
    e.preventDefault()
    if (!planData.timeline) {
      toast.warn('Timeline can not be empty!', {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
      return
    }
    setShowModal(true)
  }
  const [active, setActive] = useState('')
  const someFunct = (item: any, code: any) => {
    setActive(item)
    console.log(code)
    planData.maturity_date = addMonths(new Date(), code)
    planData.timeline = item
    dispatch(action(PlanTypes._UPDATE_PLAN_FORM, planData))
  }
  const addMonths = (date: any, months: any) => {
    var d = date.getDate()
    date.setMonth(date.getMonth() + +months)
    if (date.getDate() !== d) {
      date.setDate(0)
    }
    return (
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    )
  }
  const Disabled = () => {
    if (!planData.timeline) {
      return 'blur'
    }
    return null
  }

  return (
    <Wrapper>
      <div className="pageNumber"></div>
      <form className="content">
        <div className="top-form">
          <ModalTitleText>Timeline</ModalTitleText>
          <div className="line">
            {TIMELINE.map(function (name, index) {
              return (
                <input
                  type="button"
                  className={active === name.name ? 'active time' : 'time'}
                  value={name.name}
                  onClick={() => someFunct(name.name, name.code)}
                  key={name.code}
                />
              )
            })}
          </div>
        </div>
        <PlanAmountModal showModal={showModal} setShowModal={setShowModal} />

        <div>
          <ModalButton onClick={createPlan} className={`button ${Disabled()}`}>
            Continue
          </ModalButton>
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </form>
    </Wrapper>
  )
}

export { PlanTimeLine }
